export const _isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

export const _mountedfun = (that, isHome) => {
  if (window.location.href.indexOf('pcHome') > -1 || window.location.href.indexOf('mobileHome') > -1) {
    let obj = JSON.parse(localStorage.getItem('linkInfo'));
    that.$store.commit("setLinkInfo", obj);
    toPages(that, isHome)
    return
  }
  if (localStorage.getItem(window.location.href)) {
    let nowTime = new Date().getTime();
    let obj = JSON.parse(localStorage.getItem(window.location.href));
    if (nowTime <= obj.accessTime) {
      that.$store.commit("setLinkInfo", obj);
      toPages(that, isHome)
    } else {
      getData(that, isHome);
    }
  } else {
    getData(that, isHome);
  }
}

const getData = (that, isHome) => {
  console.log('getData', window.location.href)
  //获得数据
  that.$axios({
      method: "POST",
      url: that.$url,
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      data: {
        shortLinkUrl: window.location.href
      },
    })
    .then((response) => {
      if (response.data.data) {
        if (response.data.data.fullLinkUrl) {
          let obj = {
            openLink: response.data.data.fullLinkUrl,
            resourceUrl: response.data.data.resourceUrl || '',
            terminalType: response.data.data.terminalType || '',
            accessTime: new Date( new Date().setHours(23, 59, 59, 999)).getTime(),
          };
          localStorage.setItem(window.location.href, JSON.stringify(obj));
          localStorage.setItem('linkInfo', JSON.stringify(obj));
          that.$store.commit("setLinkInfo", {
            openLink: response.data.data.fullLinkUrl,
            resourceUrl: response.data.data.resourceUrl,
            terminalType: response.data.data.terminalType
          });
          toPages(that, isHome)
        }
      } else {
        if (response.data.errorCode != 0) {
          that.$store.commit('setError', {
            msg: response.data.msg,
            showTip: true
          })
        }
      }
    })
    .catch((error) => {
      console.log(error);
    })
}

const toPages = (that, isHome) => {
  if(that.$store.state.linkInfo.terminalType == 'Web'){
    window.location.href = that.$store.state.linkInfo.openLink
  }else{
    if (isHome) {
      that.$router.push({
        name: _isMobile() ? "mobileHome" : "pcHome"
      });
    } else if (_isMobile() && that.$route.name !== 'mobileHome') {
      that.$router.push({
        name: "mobileHome"
      })
    } else if(!_isMobile() && that.$route.name !== 'pcHome') {
      that.$router.push({
        name: "pcHome"
      })
    }
    if (_isMobile() && that.$store.state.linkInfo.openLink) {
      window.location.href = that.$store.state.linkInfo.openLink
    }
  }
}